import { LogOut, Search } from "lucide-react";

interface HeaderProps {
  email: string;
  onSignOut: () => void;
}

export function Header({ email, onSignOut }: HeaderProps) {
  const initials = (email.split("@")[0] ?? "").slice(0, 2).toUpperCase();

  return (
    <div className="flex items-center gap-3 border-b border-white/10 px-6 py-3">
      <div className="relative w-full max-w-xs">
        <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-lb-icon" />
        <input
          type="text"
          placeholder="Search Dashboard"
          className="w-full rounded-full border border-white/15 bg-white/5 py-1.5 pl-9 pr-3 text-sm text-white placeholder:text-lb-icon/70 focus:outline-none focus:ring-1 focus:ring-lb-blue"
        />
      </div>

      <div className="ml-auto flex items-center gap-3">
        <span className="hidden text-sm text-lb-icon sm:inline">{email}</span>
        <span className="flex size-8 items-center justify-center rounded-full bg-lb-blue/20 text-sm font-semibold text-white">
          {initials}
        </span>
        <button
          type="button"
          onClick={onSignOut}
          title="Sign out"
          className="flex size-8 cursor-pointer items-center justify-center rounded text-lb-icon transition-colors hover:bg-white/10 hover:text-white"
        >
          <LogOut className="size-4" />
        </button>
      </div>
    </div>
  );
}
